// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__RzJl9","title":"Select_title__Qzenk","wrapper":"Select_wrapper___voEd","Compact":"Select_Compact__7hhD1"};